import { render, staticRenderFns } from "./add_form.vue?vue&type=template&id=10c0fb2f&scoped=true"
import script from "./add_form.vue?vue&type=script&lang=js"
export * from "./add_form.vue?vue&type=script&lang=js"
import style0 from "./add_form.vue?vue&type=style&index=0&id=10c0fb2f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0fb2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c0fb2f')) {
      api.createRecord('10c0fb2f', component.options)
    } else {
      api.reload('10c0fb2f', component.options)
    }
    module.hot.accept("./add_form.vue?vue&type=template&id=10c0fb2f&scoped=true", function () {
      api.rerender('10c0fb2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/need_goods_config/components/add_form.vue"
export default component.exports